(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["conversion-tracking-events"] && !Shopify.designMode) return;
  try {
    window.addEventListener('sesami:booking:success', e => {
  // Push conversion event to Google Tag Manager's dataLayer
  // Track conversion with Google Analytics
  if (typeof gtag === 'function') {
    gtag('event', 'sesami_booking_success', {
      appointment_id: e.detail.appointmentId,
      page_location: window.location.pathname
    });
  }

  // Track conversion for Facebook Pixel
  if (typeof fbq === 'function') {
    fbq('trackCustom', 'SesamiBookingSuccess', {
      appointmentId: e.detail.appointmentId,
      page: window.location.pathname
    });
  }

  if (typeof pintrk === 'function') {
    pintrk('track', 'SesamiBookingSuccess', {
      appointmentId: e.detail.appointmentId,
      page: window.location.pathname,
    });    
  }

  if (typeof rdt === 'function') {
    rdt('track', 'SesamiBookingSuccess', {
      appointmentId: e.detail.appointmentId,
      page: window.location.pathname
    });
  }

  // Track conversion for TikTok Pixel
  if (typeof ttq === 'object' && typeof ttq.track === 'function') {
    ttq.track('SesamiBookingSuccess', {
      appointmentId: e.detail.appointmentId,
      page: window.location.pathname
    });
  }

  // Track conversion for OpenAI (ChatGPT) Ads. Count-only appointment signal:
  // makes pay-at-visit Sesami bookings (no web checkout) attributable to a
  // ChatGPT ad click. event_id is the Sesami appointment id so a future
  // server-side mirror dedupes against this browser event.
  if (typeof oaiq === 'function' && e.detail.appointmentId) {
    oaiq('measure', 'appointment_scheduled', {
      type: 'customer_action'
    }, {
      event_id: 'booking_' + e.detail.appointmentId
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gwp_js"] && !Shopify.designMode) return;
  try {
    window.raftelGwp = {
    cart: {
      refreshed: function (json) {
        let cartDrawer = document.querySelector('cart-drawer');
        cartDrawer.renderContents(json, true, false);
      }
    }
  }
  window.raftelGwpCallback = function (json) {
    let cartDrawer = document.querySelector('cart-drawer');
    cartDrawer.renderContents(json, true, false);
  }
  } catch(e) { console.error(e); }
})();

})();
